import React, { forwardRef } from 'react'
import cx from 'classnames'

import s from './Box.scss'


const allowedKeys   = [ 'm', 'mt', 'mr', 'mb', 'ml', 'p', 'pt', 'pr', 'pb', 'pl', 'pv', 'ph', 'mv', 'mh' ]
const allowedSizes  = [
  'xs', 'xsm', 'sm', 'md', 'lg', 'xlg', 'xxl', 'xxxl',
  '8', '12', '16', '24', '36', '48', '60', '96',
].concat([
  '4', '20', '32', '40', '48', '56', '64', '72', '80',
])

// $offset-96      : 96px;
// $offset-80      : 80px;
// $offset-72      : 72px;
// $offset-64      : 64px;
// $offset-60      : 60px; // deprecated?
// $offset-56      : 56px;
// $offset-48      : 48px;
// $offset-40      : 40px; // deprecated?
// $offset-36      : 36px; // deprecated?
// $offset-32      : 32px;
// $offset-24      : 24px;
// $offset-20      : 20px;
// $offset-16      : 16px;
// $offset-12      : 12px;
// $offset-8       :  8px;
// $offset-4       :  4px;

const getClasses = (keys) => {
  const classes = []

  Object.keys(keys).forEach((key) => {
    const value = keys[key]

    if (!value) {
      return
    }

    if (!allowedKeys.includes(key)) {
      console.error(`Wrong "key" – ${key} passed to Box component`)
    }

    if (!allowedSizes.includes(value) && !!allowedSizes.includes(Number(value))) {
      console.error(`Wrong "value" – ${value} passed for key "${key}" to Box component`)
    }

    const doubleClasses = ({
      pv: [ 'pt', 'pb' ],
      ph: [ 'pl', 'pr' ],
      mv: [ 'mt', 'mb' ],
      mh: [ 'ml', 'mr' ],
    })[key]

    if (doubleClasses) {
      doubleClasses.forEach((keyItem) => {
        classes.push(s[`${keyItem}_${value}`])
      })
    }
    else {
      classes.push(s[`${key}_${value}`])
    }
  })

  return classes
}

const Box = forwardRef((props, ref) => {
  const {
    children, className, id, alignCenter, alignRight, alignLeft, center, inline, style, relative, pointer, onClick, onMouseEnter, onMouseLeave, noWrapper, ...keys
  } = props

  const rootClassName = cx(className, ...getClasses(keys), {
    [s.center]: center,
    [s.inline]: inline,
    [s.alignCenter]: alignCenter,
    [s.alignRight]: alignRight,
    [s.alignLeft]: alignLeft,
    [s.relative]: relative,
    [s.pointer]: Boolean(onClick || pointer),
  })

  if (noWrapper) {
    return React.cloneElement(children, {
      className: rootClassName,
      id,
      style,
      onMouseLeave,
      onMouseEnter,
      onClick,
    })
  }

  return (
    <div
      ref={ref}
      className={rootClassName}
      id={id}
      style={style}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
    >
      {children}
    </div>
  )
})


export default React.memo(Box)
